<template>
  <header class="mobile-header" :class="{ 'header-scrolled': isScrolled }">
    <div class="mobile-header-container">
      <!-- Logo -->
      <div class="logo">
        <img src="/shcdlogo.png" alt="上海超导" class="logo-image" />
      </div>
      
      <!-- 汉堡菜单按钮 -->
      <button class="hamburger-btn" @click="toggleMenu" :class="{ 'active': isMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
    
    <!-- 移动端菜单 -->
    <div class="mobile-menu-overlay" :class="{ 'active': isMenuOpen }" @click="closeMenu">
      <nav class="mobile-nav" @click.stop>
        <div class="mobile-nav-header">
          <div class="logo">
            <img src="/shcdlogo.png" alt="上海超导" class="logo-image" />
          </div>
          <button class="close-btn" @click="closeMenu">×</button>
        </div>
        
        <ul class="mobile-nav-menu">
          <li class="mobile-nav-item">
            <router-link to="/" class="mobile-nav-link" @click="closeMenu">
              {{ t("header.home") }}
            </router-link>
          </li>
          
          <li class="mobile-nav-item">
            <div class="mobile-nav-link" @click="toggleSubmenu('company')">
              {{ t("header.company.title") }}
              <i class="arrow" :class="{ 'active': activeSubmenu === 'company' }">›</i>
            </div>
            <ul class="mobile-submenu" :class="{ 'active': activeSubmenu === 'company' }">
              <li><router-link to="/company/introduction" @click="closeMenu">{{ t("header.company.introduction") }}</router-link></li>
              <li><router-link to="/company/dream" @click="closeMenu">{{ t("header.company.dream") }}</router-link></li>
              <li><router-link to="/company/events" @click="closeMenu">{{ t("header.company.events") }}</router-link></li>
              <li><router-link to="/company/partners" @click="closeMenu">{{ t("header.company.partners") }}</router-link></li>
              <li><router-link to="/company/honors" @click="closeMenu">{{ t("header.company.honors") }}</router-link></li>
              <li><router-link to="/company/structure" @click="closeMenu">{{ t("header.company.structure") }}</router-link></li>
            </ul>
          </li>
          
          <li class="mobile-nav-item">
            <div class="mobile-nav-link" @click="toggleSubmenu('products')">
              {{ t("header.products.title") }}
              <i class="arrow" :class="{ 'active': activeSubmenu === 'products' }">›</i>
            </div>
            <ul class="mobile-submenu" :class="{ 'active': activeSubmenu === 'products' }">
              <li><router-link to="/products/tape" @click="closeMenu">{{ t("header.products.tape") }}</router-link></li>
              <li><router-link to="/products/performance" @click="closeMenu">{{ t("header.products.performance") }}</router-link></li>
              <li><router-link to="/products/advantages" @click="closeMenu">{{ t("header.products.advantages") }}</router-link></li>
              <li><router-link to="/products/service" @click="closeMenu">{{ t("header.products.service") }}</router-link></li>
            </ul>
          </li>
          
          <li class="mobile-nav-item">
            <div class="mobile-nav-link" @click="toggleSubmenu('applications')">
              {{ t("header.applications.title") }}
              <i class="arrow" :class="{ 'active': activeSubmenu === 'applications' }">›</i>
            </div>
            <ul class="mobile-submenu" :class="{ 'active': activeSubmenu === 'applications' }">
              <li><router-link to="/applications/nuclear" @click="closeMenu">{{ t("header.applications.nuclear") }}</router-link></li>
              <li><router-link to="/applications/power" @click="closeMenu">{{ t("header.applications.power") }}</router-link></li>
              <li><router-link to="/applications/magnetic" @click="closeMenu">{{ t("header.applications.magnetic") }}</router-link></li>
            </ul>
          </li>
          
          <li class="mobile-nav-item">
            <div class="mobile-nav-link" @click="toggleSubmenu('news')">
              {{ t("header.news.title") }}
              <i class="arrow" :class="{ 'active': activeSubmenu === 'news' }">›</i>
            </div>
            <ul class="mobile-submenu" :class="{ 'active': activeSubmenu === 'news' }">
              <li><router-link to="/news/company" @click="closeMenu">{{ t("header.news.company") }}</router-link></li>
              <li><router-link to="/news/downloads" @click="closeMenu">{{ t("header.news.downloads") }}</router-link></li>
            </ul>
          </li>
          
          <li class="mobile-nav-item">
            <router-link to="/recruit" class="mobile-nav-link" @click="closeMenu">
              {{ t("header.recruit") }}
            </router-link>
          </li>
          
          <li class="mobile-nav-item">
            <div class="mobile-nav-link" @click="toggleSubmenu('contact')">
              {{ t("header.contact.title") }}
              <i class="arrow" :class="{ 'active': activeSubmenu === 'contact' }">›</i>
            </div>
            <ul class="mobile-submenu" :class="{ 'active': activeSubmenu === 'contact' }">
              <li><router-link to="/contact/postdoc" @click="closeMenu">{{ t("header.contact.postdoc") }}</router-link></li>
              <li><router-link to="/contact/info" @click="closeMenu">{{ t("header.contact.info") }}</router-link></li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const isScrolled = ref(false)
const isMenuOpen = ref(false)
const activeSubmenu = ref('')

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
  activeSubmenu.value = ''
  
  // 防止背景滚动
  if (isMenuOpen.value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

const closeMenu = () => {
  isMenuOpen.value = false
  activeSubmenu.value = ''
  document.body.style.overflow = ''
}

const toggleSubmenu = (menu: string) => {
  activeSubmenu.value = activeSubmenu.value === menu ? '' : menu
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  document.body.style.overflow = ''
})
</script>

<style scoped lang="scss">
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  
  &.header-scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  }
}

.mobile-header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  height: 60px;
}

.logo {
  height: 40px;
  
  .logo-image {
    height: 100%;
    width: auto;
  }
}

.hamburger-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  position: relative;
  
  span {
    display: block;
    height: 2px;
    width: 100%;
    background: #333;
    margin: 3px 0;
    transition: all 0.3s ease;
    transform-origin: center;
  }
  
  &.active {
    span:nth-child(1) {
      transform: rotate(45deg) translate(6px, 6px);
    }
    
    span:nth-child(2) {
      opacity: 0;
    }
    
    span:nth-child(3) {
      transform: rotate(-45deg) translate(6px, -6px);
    }
  }
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 999;
  
  &.active {
    opacity: 1;
    visibility: visible;
  }
}

.mobile-nav {
  position: absolute;
  top: 0;
  right: 0;
  width: 280px;
  height: 100vh;
  background: #fff;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
  
  .mobile-menu-overlay.active & {
    transform: translateX(0);
  }
}

.mobile-nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  
  .close-btn {
    background: none;
    border: none;
    font-size: 30px;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.mobile-nav-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav-item {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f8f9fa;
  }
  
  .arrow {
    font-style: normal;
    transition: transform 0.3s ease;
    font-size: 18px;
    color: #666;
    
    &.active {
      transform: rotate(90deg);
    }
  }
}

.mobile-submenu {
  list-style: none;
  padding: 0;
  margin: 0;
  background: #f8f9fa;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  
  &.active {
    max-height: 300px;
  }
  
  li {
    border-bottom: 1px solid #e9ecef;
    
    &:last-child {
      border-bottom: none;
    }
    
    a {
      display: block;
      padding: 12px 20px 12px 40px;
      color: #666;
      text-decoration: none;
      font-size: 14px;
      transition: all 0.2s ease;
      
      &:hover {
        background-color: #e9ecef;
        color: #333;
      }
    }
  }
}

@media screen and (min-width: 769px) {
  .mobile-header {
    display: none;
  }
}
</style> 